import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@codex-brightworld/icons';
import styled from 'styled-components';
import DefaultLink from '../Link/Link';

const Link = styled(DefaultLink)`
  display: flex;
  align-items: flex-end;

  ${Icon} {
    stroke: none;
    width: 22px;
    height: 19px;
  }
`;

const LabelWrapper = styled.span`
  padding: 0 7px;
`;

function Print(props) {
  return (
    <Link href="#" onClick={props.print} data-qa={props.qa}>
      <Icon icon="printer" />
      {props.label && (
        <LabelWrapper>
          {props.label}
        </LabelWrapper>
      )}
    </Link>
  );
}

Print.propTypes = {
  label: PropTypes.string,
  print: PropTypes.func,
  qa: PropTypes.string
};

Print.defaultProps = {
  label: '',
  print: typeof window !== 'undefined' ? window.print : () => {},
  qa: undefined
};

/** @component */
export default Print;
